import { render } from "./padel-checkbox.template.html?vue&type=template&id=e55fd9ea&scoped=true"
import script from "./PadelCheckbox.vue?vue&type=script&lang=ts"
export * from "./PadelCheckbox.vue?vue&type=script&lang=ts"

import "./PadelCheckbox.vue?vue&type=style&index=0&id=e55fd9ea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e55fd9ea"

export default script